__turbopack_context__.v({
  "btn": "Button-module-scss-module__nJGxwW__btn",
  "btn-icon-right": "Button-module-scss-module__nJGxwW__btn-icon-right",
  "btn-large": "Button-module-scss-module__nJGxwW__btn-large",
  "btn-medium": "Button-module-scss-module__nJGxwW__btn-medium",
  "btn-primary": "Button-module-scss-module__nJGxwW__btn-primary",
  "btn-secondary": "Button-module-scss-module__nJGxwW__btn-secondary",
  "btn-small": "Button-module-scss-module__nJGxwW__btn-small",
  "is-full": "Button-module-scss-module__nJGxwW__is-full",
  "light": "Button-module-scss-module__nJGxwW__light",
});
